import React from 'react';
import {ReactNode} from 'react';
import { Switch } from 'antd';
import type { SwitchChangeEventHandler,SwitchSize,SwitchClickEventHandler } from 'antd/es/switch';
import './switch.scss';

type SwitchComponentParams = {
    className:string
    onClickEvent: SwitchClickEventHandler 
    onChangeEvent?: SwitchChangeEventHandler 
    style?: {}
    checkedChildren?:ReactNode
    unCheckedChildren?:ReactNode
    defaultChecked?:boolean
    disabled?:boolean
    checked?:boolean
    size?:SwitchSize
    // children?: ReactNode
}

const SwitchComponent = ({
    className = '',
    onClickEvent,
    onChangeEvent,
    style = {},
    checkedChildren = '',
    unCheckedChildren = '',
    defaultChecked = false,
    disabled = false,
    checked = false,
    size = 'default',
    // ...props
}:SwitchComponentParams) => {
    return (
        <Switch
            className={className}
            onChange={onChangeEvent}
            onClick={onClickEvent}
            style={style}
            disabled={disabled}
            checkedChildren={checkedChildren}
            unCheckedChildren={unCheckedChildren}
            defaultChecked={defaultChecked}
            checked={checked}
            size={size}
        />
    );
};

export default SwitchComponent;
